/// <reference path="../app.ts" />


namespace Cfnc {
    "use strict";

    interface IHeSAssessments {
        activate: () => void;
        assessment: string;
        url: string;
        assessmentName: string;
        isLicensed: boolean;
        configId: number;
    }


    class HeSAssessments implements IHeSAssessments {
        static controllerId: string = "heSAssessments";
        static $inject: string[] = ["common", "config", "Restangular", "$routeParams", "$sce", "$window", "$scope", "$http", "hesfactory", "routemediator"];

        assessment: string;
        url: string;
        assessmentName: string;
        isLicensed = true;
        isLsi: boolean;
        configId: number;
        assessmentClient: any;
        assessmentId: string;
        formerName: string;


        constructor(private common: ICommonFactory, private config: IConfig, private Restangular: Restangular.IService, private $routeParams: ng.route.IRouteParamsService, private $sce: ng.ISCEService, private $window: ng.IWindowService, private $scope: ng.IScope, private $http: ng.IHttpService, private hesFactory: IHesFactory, private routemediator: IRouteMediator) {

            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.assessment = $routeParams["assessment"].toLowerCase();
                    this.assessmentClient = this.hesFactory as any;
                switch (this.assessment) {
                    case "achieveworks-personality":
                    case "personality":
                    case "dwya":
                        this.assessmentName = "AchieveWorks\u00AE Personality";
                        this.formerName = "Do What You Are"
                        this.isLsi = false;
                        _.last(this.routemediator.breadCrumbs).config.title = "Achieveworks Personality";
                        this.configId = 104;
                        break;
                    case "achieveworks-learning-productivity":
                    case "learningproductivity":
                    case "lsi":
                        this.assessmentName = "AchieveWorks\u00AE Learning & Productivity";
                        this.formerName = "Learning Style Inventory"
                        this.isLsi = true;
                        _.last(this.routemediator.breadCrumbs).config.title = "Achieveworks Learning & Productivity";
                        this.configId = 101
                        break;
                    case "achieveworks-skills":
                    case "skills":
                        this.assessmentName = "AchieveWorks\u00AE Skills";
                        this.formerName = ""
                        this.isLsi = false;
                        _.last(this.routemediator.breadCrumbs).config.title = "Achieveworks Skills";
                        this.configId = 1700
                        break;
                    case "achieveworks-intelligences":
                    case "intelligences":
                        this.assessmentName = "AchieveWorks\u00AE Intelligences";
                        this.formerName = ""
                        this.isLsi = false;
                        _.last(this.routemediator.breadCrumbs).config.title = "Achieveworks Intelligences";
                        this.configId = 100
                        break;
                    default:
                        this.assessmentName = "";
                        break;
                }

                this.activate();
                }
            });

            
        }

        activate() {
            var promises = [this.getAssessments()];
            this.common.activateController(promises, HeSAssessments.controllerId)
                .then(() => {
                   this.getAssessment(this.assessmentId);
                });
        }

        getAssessments = (): ng.IPromise<any> => {
            return this.Restangular.all("hes").one("assessments").get({ configId: this.configId })
                .then((assessments) => {
                    this.assessmentId = assessments && assessments[0] != null ? assessments[0].id : null;
                });
        }

        getAssessment = (assessmentId): ng.IPromise<any> => {
            return this.Restangular.all("hes").one("getToken").get()
                .then((model) => {
                    var config: any = {
                        //required
                        "apiEnvironment": this.config.hesEnvironment,
                        //"clientBaseUrl": "https://services.test.humanesources.com/api/assessments",
                        "configurationId": this.configId.toString(),
                        "userId": model.heSUserId.toString(), //use a valid user id
                        "apiToken": model.token, //use the token returned from getApiToken api call
                        "applicationDivId": "hesapp",
                        //example function to handle start assessment by adding the id to the url
                        "onAssessmentStart": (assessment) => window.history.
                            replaceState({}, null, `${window.location}/${assessment.id}`),
                    }

                    if (assessmentId) {
                        config.assessmentId = assessmentId;
                    }

                    this.assessmentClient(config);
                }, (error) => {
                    console.error(error);
                });
        }

        getIFrameUrl = (): ng.IPromise<any> => {
            var deferred = this.common.$q.defer();
            this.Restangular.all("learnaboutyourself").one(this.assessment).get()
                .then((result) => {
                    this.url = this.$sce.trustAsResourceUrl(result);
                    console.log(result);
                    deferred.resolve(result);

                }, (reason) => {
                    if (reason.data.modelState && reason.data.modelState.notLicensed) {
                        this.isLicensed = false;
                    }
                });

            return deferred.promise;
        };

        updateDWYAResults = () => {
            var working = true;
            this.Restangular.all("users").one("profile").get().then((result) => {
                var xhttp = new XMLHttpRequest();
                xhttp.onreadystatechange = function () {
                    if (this.readyState == 4) {
                        console.log("Done!");
                    }
                }

                xhttp.open("GET", this.config.transitionsUrl + "/cfitransitions/LearnAboutYourself/HeS.svc/UpdateDWYAType?hesUserId=" + result.heSUserId, false);
                xhttp.withCredentials = true;
                xhttp.send();
            });


        };


    }

    angular.module("app").controller(HeSAssessments.controllerId, HeSAssessments);
}